import Navbar from "../../components/common/Navbar.js";
import Overview from "../../components/profile/overview/Overview";
import Trophies from "../../components/profile/trophies/Trophies";
import Achievements from "../../components/profile/trophies/Achievements";
import Tabs from "../../components/team-hub/Tabs";
import { useState } from "react";
import Header from "../../components/common/Header.js";
import { useUser } from "../../context/useUser";
import Footer from "../../components/common/Footer.js";
import { FC } from "react";
import {useLeague} from "../../context/useLeague";

const Profile: FC = ({}) => {
  const [component, setComponent] = useState("Profile");
  const components = ["Profile", "Trophies", "Achievements"];

  // get player from user object
  const { user } = useUser();

  return (
    <>
      <Navbar />
      <Header title={"Profile"} />
      <div className="container body " id="custom-team-hub">
        <div className="row">
          <div className="col mt-2">
            <Tabs
              components={components}
              setComponent={setComponent}
              component={component}
            />
          </div>
          <div className="w-100"></div>
          <div className="col " id="background">
            {component === "Profile" && user && <Overview player={user} />}
            {/* { component === "Stats" && <Stats/> } */}
            {component === "Trophies" && <Trophies />}
            {component === "Achievements" && <Achievements />}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Profile;

